(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["gsa-image-carousel"] && !Shopify.designMode) return;
  try {
    /* GSA custom */
  if (!customElements.get('gsa-image-carousel')) {
    customElements.define('gsa-image-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.gsa-ic__track');
        this.slides = [...this.querySelectorAll('.gsa-ic__slide')];
        this.dots = [...this.querySelectorAll('.gsa-ic__dot')];
        if (this.slides.length < 2) return;
        this.index = 0;
        this.querySelector('.gsa-ic__arrow--prev')?.addEventListener('click', () => this.go(this.index - 1));
        this.querySelector('.gsa-ic__arrow--next')?.addEventListener('click', () => this.go(this.index + 1));
        this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i)));
        this.track.addEventListener('scroll', () => {
          clearTimeout(this._t);
          this._t = setTimeout(() => this.sync(), 60);
        }, { passive: true });
        this.track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1); }
        });
        const secs = parseInt(this.dataset.autoplay, 10) || 0;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (secs > 0 && !reduce) {
          this.paused = false;
          ['mouseenter', 'focusin', 'touchstart'].forEach((ev) => this.addEventListener(ev, () => { this.paused = true; }, { passive: true }));
          ['mouseleave', 'focusout'].forEach((ev) => this.addEventListener(ev, () => { this.paused = false; }));
          this.timer = setInterval(() => { if (!this.paused && !document.hidden) this.go(this.index + 1); }, secs * 1000);
        }
      }
      disconnectedCallback() { clearInterval(this.timer); }
      go(i) {
        const n = this.slides.length;
        this.index = (i + n) % n;
        this.track.scrollTo({ left: this.slides[this.index].offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        this.mark();
      }
      sync() {
        const w = this.track.clientWidth || 1;
        this.index = Math.round(this.track.scrollLeft / w);
        this.mark();
      }
      mark() {
        this.dots.forEach((d, i) => { if (i === this.index) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
